import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Button,
  Card,
  CardHeader,
  CardBody,
  Label,
  CardFooter,
} from "reactstrap";
import { useSafariPaymentReset } from "../../hooks/useSafariPaymentReset";
import CustomInput from "../custom/CustomInput";
import CustomSelect from "../custom/CustomSelect";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as actions from "../../redux/creators";
import * as Yup from "yup";
import { useSelector, useDispatch, batch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CircularLoading from "../loader/CircularIndeterminate";
import { Autocomplete, TextField } from "@mui/material";
const DanceWorkshop = () => {
  const dispatch = useDispatch();
  const { isPostLoading } = useSelector((state) => state.coursereg);
  // const { courses } = useSelector((state) => state.courses);
  const { courseByEvents, isLoading } = useSelector(
    (state) => state.courseByEvents
  );
  const { batches } = useSelector((state) => state.batches);

  const data = {
    id: "1",
  };

  useEffect(() => {
    dispatch(actions.courseByEventsGetData(data));
    dispatch(actions.batchesGetData()); 
  }, []);
  const defaultProps = {
    options: courseByEvents,
    getOptionLabel: (option) => option.name,
  };
  const handleSubmit = (values, { setSubmitting }) => {
    const coursereg = {
      clientname: values.clientname,
      clientemail: values.clientemail,
      clientphone: values.clientphone,
      age: values.age,
      city: values.city,
      course_id: values.course_id,
      is_enquiry: values.is_enquiry,
      totalfees: values.totalfees,
      batch_id: values.batch_id,
      time_slot_id: values.time_slot_id,
    };
    dispatch(actions.postCourse(coursereg, setSubmitting));
    setSubmitting(true);
    return;
  };
  return (
    <React.Fragment>
      <Container>
        <div className="bg-white">
          <Row>
            <h5 className="text-center p-3">
              Please fill the form to register for batches.
            </h5>
          </Row>
          <Card>
            <CardBody>
              <Formik
                initialValues={{
                  clientname: "",
                  clientemail: "",
                  clientphone: "",
                  age: "",
                  city: "Mumbai",
                  course_id: "",
                  totalfees: "0",
                  is_enquiry: "1",
                  batch_id: "",
                  time_slot_id: "",
                }}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape({
                  clientemail: Yup.string()
                    .required("Enter Your Email")
                    .email("Invalid Email address"),
                  clientname: Yup.string().required("required"),
                  clientphone: Yup.string().required("required"),
                })}
              >
                {(formProps) => (
                  <Form className="mt-3">
                    {console.log("formProps", formProps.values)}
                    <Row className="form-group mt-3">
                      <Col md={12}>
                        <Label htmlFor="clientname" className="label">
                          Your Full Name:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="clientname"
                            id="clientname"
                            placeholder="Enter Your Name"
                            className={
                              "form-control" +
                              (formProps.errors.clientname &&
                              formProps.touched.clientname
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="clientname"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group mt-3">
                      <Col md={6}>
                        <Label htmlFor="clientemail" className="label">
                          Your Email:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="clientemail"
                            id="clientemail"
                            placeholder="Enter Your Email"
                            className={
                              "form-control" +
                              (formProps.errors.clientemail &&
                              formProps.touched.clientemail
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="clientemail"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                      <Col md={6}>
                        <Label htmlFor="clientphone" className="label">
                          Your Mobile:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="clientphone"
                            id="clientphone"
                            placeholder="Enter Your Mobile"
                            className={
                              "form-control" +
                              (formProps.errors.clientphone &&
                              formProps.touched.clientphone
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="clientphone"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group mt-3">
                      <Col md={6}>
                        <Label htmlFor="age" className="label">
                          Your Age:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="age"
                            id="age"
                            placeholder="Enter Your Age"
                            className={
                              "form-control" +
                              (formProps.errors.age && formProps.touched.age
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="age"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                      <Col md={6}>
                        <Label htmlFor="city" className="label">
                          Your Residence City:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="city"
                            id="city"
                            placeholder="Enter Your Residence City"
                            className={
                              "form-control" +
                              (formProps.errors.city && formProps.touched.city
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="city"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group mt-3">
                      <Col md={6}>
                        <Label htmlFor="course_id" className="label">
                          Your Course:
                        </Label>
                        <InputGroup>
                          <Autocomplete
                            {...defaultProps}
                            id="course_id"
                            name="course_id"
                            getOptionSelected={(option, value) =>
                              option.id === value.id
                            }
                            onChange={(event, newValue) => {
                              console.log("new", newValue);
                              formProps.setFieldValue(
                                `course_id`,
                                newValue?.id ?? ""
                              );
                              formProps.setFieldValue(
                                `totalfees`,
                                newValue?.total_amount ?? ""
                              );
                            }}
                            sx={{ width: "100%" }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Course Name *"
                                variant="outlined"
                                name="course_id"
                                size="small"
                                className="form-control"
                                error={
                                  formProps.touched.course_id &&
                                  Boolean(formProps.errors.course_id)
                                }
                                helperText={
                                  formProps.touched.course_id &&
                                  formProps.errors.course_id
                                }
                              />
                            )}
                          />
                        </InputGroup>
                      </Col>
                      <Col md={6}>
                        <Label htmlFor="totalfees" className="label">
                          Your Amount:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            disabled
                            name="totalfees"
                            id="totalfees"
                            placeholder="Enter Amount"
                            className={
                              "form-control" +
                              (formProps.errors.totalfees &&
                              formProps.touched.totalfees
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="totalfees"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>

                    <Row className="form-group mt-3">
                      <Col md={6}>
                        <Label htmlFor="batch_id" className="label">
                          Choose Start Date:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomSelect}
                            type="select"
                            name="batch_id"
                            id="batch_id"
                            placeholder="Enter Start Date"
                            className={
                              "form-control" +
                              (formProps.errors.batch_id &&
                              formProps.touched.batch_id
                                ? " is-invalid"
                                : "")
                            }
                          >
                            <option value="">Choose Start Date</option>
                            {batches.length > 0 &&
                              batches.map((itm) => {
                                if (itm.course_id == formProps.values.course_id)
                                  return (
                                    <option value={itm.id} key={itm.id}>
                                      {itm.name}
                                    </option>
                                  );
                              })}
                          </Field>
                          <ErrorMessage
                            name="batch_id"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                      <Col md={6}>
                        <Label htmlFor="time_slot_id" className="label">
                          Choose Batch Time (IST):
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomSelect}
                            type="select"
                            name="time_slot_id"
                            id="batch_id"
                            placeholder="Enter Your Batch"
                            className={
                              "form-control" +
                              (formProps.errors.batch_id &&
                              formProps.touched.batch_id
                                ? " is-invalid"
                                : "")
                            }
                          >
                            <option>Choose Batch Time (IST)</option>
                            {batches.length > 0 &&
                              batches
                                .filter(
                                  (i) => formProps.values.batch_id == i.id
                                )[0]
                                ?.time_slots.map((itm) => {
                                  return (
                                    <option value={itm.id} key={itm.id}>
                                      {itm.start_time} to {itm.end_time}
                                    </option>
                                  );
                                })}
                          </Field>
                          <ErrorMessage
                            name="batch_id"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>

                    {/* <Row className="form-group mt-3">
                      <Col md={6}>
                        <InputGroup>
                          <Field type="radio" name="picked" value="One" />
                          <span className="radiobtn"> &nbsp;Pay Online</span>
                          <ErrorMessage
                            name="branch"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row> */}
                    <Row className="form-group mt-3">
                      <Col md={6}>
                        <InputGroup>
                          <Field type="checkbox" name="checked" value="One" />

                          <span className="radiobtn">
                            {" "}
                            &nbsp;Please Accept Terms & Condition
                          </span>
                          <ErrorMessage
                            name="branch"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <div className="mt-3 mb-3 row mt-5">
                      <div className="col-12">
                        <Button
                          type="submit"
                          className="register-btn"
                          size="md"
                          block
                        >
                          {isPostLoading ? <CircularLoading /> : "REGISTER NOW"}
                        </Button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </CardBody>
            {/* <CardFooter>{isPostLoading && <CircularLoading />}</CardFooter> */}
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default DanceWorkshop;
